export const REPORT_OPTIONS = [
    {
        id: 14, name: 'Araç Bilgileri', columnOrder: [
            "Sase",
            // "MarkaCode",
            "MarkaAdi",
            //"ModelCode",
            "ModelAdi",
            "Versiyon",
            // "RenkCode",
            "RenkAdi",
            "TurkiyeLimanGirisTarihi",
            "BLOKAJ DURUM",
            "BlokajTarih",
            "StatuAciklama",
            "ParkAdres",
            "ParkBolge",
            "SON HAREKET ADI",
            "SON HAREKET TARİHİ",
            "DepoAdi",
            "Gümrüklenme Tarihi",
            "GemiAdi",
            "FaturaNo",
            "FaturaTarih",
            "FaturaClientCode",
            "FaturaClientName",
            "MillilesmisArac",
            "GENEL BLOKAJ DURUM",
            "GENEL BLOKAJ TARİHİ",
            "GENEL BLOKAJ KALDIRMA TARİHİ",
            "PDI DURUM",
            "PDI TARİHİ"
        ]
    },
    {
        id: 15, name: 'Grupaj Bilgileri', columnOrder: [
            "GrupajNo",
            "SevkiyatTipiAdi",
            "RotaAdi",
            "Sase",
            "GrupajTarih",
            "PlanlamaTarih",
            "BilgiGelisTarih",
            "IrsaliyeTarih",
            "MatbuIrsaliyeNo",
            "KapiCikisTarih",
            "TaseronFirmaAdi",
            "TirPlaka",
            "TirSoforAdiSoyadi",
            "GrupajStatuAciklama",
            "FromLokasyonAdi",
            "FromLokasyonIl",
            "ToLokasyonAdi",
            "JustToLokasyonAdi",
            "ToLokasyonIl",
            "ToLokasyon",
            "PeronAciklama",
            "SevkiyatNotu",
            "PDI",
            "DorsePlaka",
            "TirEslemeTarih",
            "SevkHazirlikTarih",
            "MarkaAdi",
            "Versiyon",
            "ModelAdi",
            "RenkAdi",
            "ToLokasyonBolgeCode",
            "FizikiYuklemeTarih",
            "FizikiTeslimTarih",
            "OtomobilDurum",
            "DepoParkAdres",
            "SaseAdresBolge",
            "PDIDurum",
            "FaturaTarihiBilgisi",
            "PDITarih",
            "CreUserCode",
            "ModUserCode"
        ]
    },
    {
        id: 16, name: 'Araç Hareketleri', columnOrder: [
            "Sase",
            "Marka",
            "Model",
            "AracHareketAdi",
            "FromLokasyon",
            "ToLokasyon",
            "FromAdresAciklama",
            "ToAdresAciklama",
            "HappenedDate",
            "HappenedUsreName"
        ]
    },
    {
        id: 17, name: 'Emir Listeleri', columnOrder: [
            "Sase",
            "EmirAdi",
            "EmirStatuAciklama",
            "EmirGirisTarih",
            "GerceklesmeTarihi",
            "EmriOlusturan"

        ]
    },
    {
        id: 18, name: 'Gemi Bilgileri',
        columnOrder: [
            "Sase",
            "MarkaAdi",
            "ModelCode",
            "ModelAdi",
            "Versiyon",
            "RenkCode",
            "RenkAdi",
            "GemiAdi",
            "TurkiyeLimanVarisTarihi"
        ]
    },
    { id: 0, name: 'Hasar Kayıtları' }
]; 